<div class="modal fade" id="kt_modal_vehicle_type_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Vehicle Type' : 'Add Vehicle Type' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="vehicleTypeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Vehicle Type Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter vehicle type name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Vehicle type name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Vehicle type name must be at least 2 characters</div>
              </div>
            </div>

            <!-- M3 -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">M3</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="m3"
                placeholder="Enter M3 value"
                [class.is-invalid]="m3?.invalid && m3?.touched"
              />
              <div *ngIf="m3?.invalid && m3?.touched" class="invalid-feedback">
                <div *ngIf="m3?.errors?.['required']">M3 is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
